/**
 * Rounds a given number to a specified number of decimal places.
 *
 * - If the input is already an integer, it returns the number as-is.
 * - If the input is a floating-point number, it rounds it to the given `decimals` (default: 2).
 * - **Removes unnecessary trailing zeros** from the decimal part after rounding.
 *
 * @param {number} value - The number to be rounded.
 * @param {number} [decimals=2] - The number of decimal places to round to (default is 2).
 * @returns {number} - The rounded number with trailing zeros removed.
 *
 * @example
 * roundToFixed(1.00);   // Returns: 1
 * roundToFixed(2.000);  // Returns: 2
 * roundToFixed(3.50);   // Returns: 3.5
 * roundToFixed(4.5678); // Returns: 4.57
 */
export const roundToFixed = (value: number, decimals = 2): number => {
  return Number.isInteger(value) ? value : Number.parseFloat(value.toFixed(decimals));
};
